import { render } from "./FarmerDetailPage.vue?vue&type=template&id=2d3df91c"
import script from "./FarmerDetailPage.vue?vue&type=script&lang=js"
export * from "./FarmerDetailPage.vue?vue&type=script&lang=js"

import "./FarmerDetailPage.vue?vue&type=style&index=0&id=2d3df91c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__